import httpRequest from '@/utils/httpRequest'
import qs from 'qs'
import config from '@/config/url.config';
export const login = function(data) {
  //登录
    return httpRequest({
      url: config.login,
      method: 'POST',
      data:qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    });
  };
